import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import Axios from 'axios';
import Sidebar from './SideBar';
import Swal from 'sweetalert2';
import config from './Componentes/config';
import useAuthRedirect from './Componentes/auth';
import { registrarLog } from './Componentes/logService';
import $ from "jquery";

const CentroCostos = () => {
    useAuthRedirect();
    const [cookies] = useCookies(['idEmpresa', 'NombreEmpresa', 'selectedCard', 'usuario']);
    const idEmpresa = cookies.idEmpresa;
    const nombreEmpresa = cookies.NombreEmpresa;
    const userName = cookies.usuario;

    // Estados para el colapso del sidebar (igual que Inventario)
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);

    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prev => !prev);
    };

    // Estados principales
    const [centrosCostos, setCentrosCostos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editingCentro, setEditingCentro] = useState(null);

    // Estados del formulario
    const [formData, setFormData] = useState({
        nombre: '',
        descripcion: '',
        codigo: '',
        activo: true
    });

    // Errores de validación
    const [errors, setErrors] = useState({});

    // Cargar datos iniciales
    useEffect(() => {
        if (idEmpresa) {
            fetchCentrosCostos();
        }
    }, [idEmpresa]);

    const fetchCentrosCostos = async () => {
        try {
            setLoading(true);
            const response = await Axios.get(`${config.API_URL}/api/centro-costos?idEmpresa=${idEmpresa}`);
            console.log('Datos de centros de costos:', response.data); // Debug temporal

            // Asegurar que siempre sea un array
            const data = response.data;
            if (Array.isArray(data)) {
                setCentrosCostos(data);
            } else {
                console.warn('Los datos recibidos no son un array:', data);
                setCentrosCostos([]);
            }
        } catch (error) {
            console.error('Error al cargar centros de costos:', error);
            setCentrosCostos([]); // Asegurar array vacío en caso de error
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar los centros de costos'
            });
        } finally {
            setLoading(false);
        }
    };

    // Inicializar DataTable cuando se cargan los centros de costos
    useEffect(() => {
        // Verificar que centrosCostos sea un array y tenga elementos
        if (Array.isArray(centrosCostos) && centrosCostos.length > 0) {
            // Destruir DataTable existente si existe
            if (window.$ && window.$.fn.DataTable.isDataTable('#centrosCostosTable')) {
                window.$('#centrosCostosTable').DataTable().destroy();
            }

            // Inicializar nuevo DataTable
            setTimeout(() => {
                if (window.$ && window.$('#centrosCostosTable').length > 0) {
                    window.$('#centrosCostosTable').DataTable({
                        language: {
                            "sProcessing": "Procesando...",
                            "sLengthMenu": "Mostrar _MENU_ registros",
                            "sZeroRecords": "No se encontraron resultados",
                            "sEmptyTable": "Ningún dato disponible en esta tabla",
                            "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                            "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                            "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                            "sInfoPostFix": "",
                            "sSearch": "Buscar:",
                            "sUrl": "",
                            "sInfoThousands": ",",
                            "sLoadingRecords": "Cargando...",
                            "oPaginate": {
                                "sFirst": "Primero",
                                "sLast": "Último",
                                "sNext": "Siguiente",
                                "sPrevious": "Anterior"
                            },
                            "oAria": {
                                "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                                "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                            }
                        },
                        responsive: true,
                        pageLength: 10,
                        order: [[1, 'asc']] // Ordenar por nombre
                    });
                }
            }, 100);
        }
    }, [centrosCostos]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Limpiar errores al escribir
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.nombre.trim()) {
            newErrors.nombre = 'El nombre es obligatorio';
        }

        if (!formData.codigo.trim()) {
            newErrors.codigo = 'El código es obligatorio';
        } else if (formData.codigo.length > 10) {
            newErrors.codigo = 'El código no puede tener más de 10 caracteres';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {
            const dataToSend = {
                ...formData,
                idEmpresa
            };

            if (editingCentro) {
                await Axios.put(`${config.API_URL}/api/centro-costos/${editingCentro.id}`, dataToSend);

                // Registrar edición en log
                await registrarLog({
                    Usuario: userName,
                    Modulo: 'CentroCostos',
                    Detalle: `Centro de costo editado: ${formData.nombre} (${formData.codigo}) en empresa ${nombreEmpresa}`,
                    Estado: 'Éxito',
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Centro de costo actualizado correctamente'
                });
            } else {
                await Axios.post(`${config.API_URL}/api/centro-costos`, dataToSend);

                // Registrar creación en log
                await registrarLog({
                    Usuario: userName,
                    Modulo: 'CentroCostos',
                    Detalle: `Centro de costo creado: ${formData.nombre} (${formData.codigo}) en empresa ${nombreEmpresa}`,
                    Estado: 'Éxito',
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Centro de costo creado correctamente'
                });
            }

            setShowModal(false);
            resetForm();
            fetchCentrosCostos();
        } catch (error) {
            console.error('Error al guardar centro de costo:', error);

            // Registrar error en log
            await registrarLog({
                Usuario: userName,
                Modulo: 'CentroCostos',
                Detalle: `Error al ${editingCentro ? 'editar' : 'crear'} centro de costo ${formData.nombre || 'sin nombre'} - ${error.response?.data?.message || error.message}`,
                Estado: 'Error',
            });

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Error al guardar el centro de costo'
            });
        }
    };

    const handleEdit = (centro) => {
        // Validar que el centro existe y tiene las propiedades necesarias
        if (!centro || typeof centro !== 'object') {
            console.error('Centro de costo inválido:', centro);
            return;
        }

        setEditingCentro(centro);
        setFormData({
            nombre: centro.nombre || '',
            descripcion: centro.descripcion || '',
            codigo: centro.codigo || '',
            activo: centro.activo === 1 || centro.activo === true
        });
        setShowModal(true);
    };

    const handleDelete = async (centro) => {
        // Validar que el centro existe
        if (!centro || !centro.id) {
            console.error('Centro de costo inválido para eliminar:', centro);
            return;
        }

        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Deseas eliminar el centro de costo "${centro.nombre || 'Sin nombre'}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await Axios.delete(`${config.API_URL}/api/centro-costos/${centro.id}`);

                // Registrar eliminación en log
                await registrarLog({
                    Usuario: userName,
                    Modulo: 'CentroCostos',
                    Detalle: `Centro de costo eliminado: ${centro.nombre || 'Sin nombre'} (${centro.codigo || 'Sin código'}) de empresa ${nombreEmpresa}`,
                    Estado: 'Éxito',
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Eliminado',
                    text: 'Centro de costo eliminado correctamente'
                });
                fetchCentrosCostos();
            } catch (error) {
                console.error('Error al eliminar centro de costo:', error);

                // Registrar error en log
                await registrarLog({
                    Usuario: userName,
                    Modulo: 'CentroCostos',
                    Detalle: `Error al eliminar centro de costo ${centro.nombre || 'Sin nombre'} - ${error.response?.data?.message || error.message}`,
                    Estado: 'Error',
                });

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo eliminar el centro de costo'
                });
            }
        }
    };

    const resetForm = () => {
        setFormData({
            nombre: '',
            descripcion: '',
            codigo: '',
            activo: true
        });
        setEditingCentro(null);
        setErrors({});
    };

    const handleCloseModal = () => {
        setShowModal(false);
        resetForm();
    };

    const confirmSubmit = () => {
        Swal.fire({
            title: '¿Está seguro?',
            text: editingCentro ? '¿Desea actualizar este centro de costo?' : '¿Desea registrar este centro de costo?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: editingCentro ? 'Sí, actualizar' : 'Sí, registrar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                handleSubmit({ preventDefault: () => { } });
            }
        });
    };

    const cardImages = {
        DAFA: "/img/dafaLogo.png",
        FUGA: "/img/fugarLogo.png",
        INVE: "/img/idafaLogo.png",
        TRAN: "/img/extasisLogo.png",
        NIDI: "/img/nidiamLogo.png"
    };
    const imageUrl = cardImages[cookies.selectedCard];

    if (loading) {
        return (
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    cookies={cookies}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                <div className="text-center">
                                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="sr-only">Cargando...</span>
                                    </div>
                                    <p className="mt-3 text-muted">Cargando centros de costos...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar
                imageUrl={imageUrl}
                isComponentsCollapsed={isComponentsCollapsed}
                toggleCollapse={toggleCollapse}
                setIsComponentsCollapsed={setIsComponentsCollapsed}
                isUtilitiesCollapsed={isUtilitiesCollapsed}
                setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                isContabilidadCollapsed={isContabilidadCollapsed}
                setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                isPrevencion={isPrevencion}
                setisPrevencionCollapsed={setisPrevencionCollapsed}
                isLogistica={isLogistica}
                setisLogisticaCollapsed={setisLogisticaCollapsed}
                isInventario={isInventario}
                setisIventatioCollapsed={setisIventatioCollapsed}
                cookies={cookies}
            />

            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        {/* Header */}
                        <div className="d-sm-flex align-items-center justify-content-between mb-4">
                            <h1 className="h3 mb-0 text-gray-800">
                                <i className="fas fa-account-balance"></i> Centro de Costos - {nombreEmpresa}
                            </h1>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    resetForm();
                                    setShowModal(true);
                                }}
                            >
                                <i className="fas fa-plus"></i> Nuevo Centro de Costo
                            </button>
                        </div>

                        {/* Tabla de centros de costos */}
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <h6 className="m-0 font-weight-bold text-primary">
                                    <i className="fas fa-list"></i> Lista de Centros de Costos
                                </h6>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered" id="centrosCostosTable" width="100%" cellSpacing="0">
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Nombre</th>
                                                <th>Descripción</th>
                                                <th>Estado</th>
                                                <th>Fecha Creación</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(centrosCostos) && centrosCostos.length > 0 ? (
                                                centrosCostos.map((centro) => (
                                                    <tr key={centro.id}>
                                                        <td>
                                                            <span className="badge badge-primary" style={{ minWidth: '60px', textAlign: 'center', backgroundColor: '#000', color: '#fff' }}>{centro.codigo || 'N/A'}</span>
                                                        </td>
                                                        <td className="font-weight-bold">{centro.nombre || 'Sin nombre'}</td>
                                                        <td>{centro.descripcion || '-'}</td>
                                                        <td>
                                                            <span
                                                                className={`badge ${centro.activo == 1 || centro.activo === true ? 'badge-success' : 'badge-secondary'}`}
                                                                style={{
                                                                    minWidth: '70px',
                                                                    textAlign: 'center',
                                                                    backgroundColor: centro.activo == 1 || centro.activo === true ? '#28a745' : '#6c757d',
                                                                    color: '#fff'
                                                                }}
                                                            >
                                                                {centro.activo == 1 || centro.activo === true ? 'Activo' : 'Inactivo'}
                                                            </span>
                                                        </td>
                                                        <td>{centro.fecha_creacion ? new Date(centro.fecha_creacion).toLocaleDateString() : 'N/A'}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-warning btn-sm mr-1"
                                                                onClick={() => handleEdit(centro)}
                                                                title="Editar"
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => handleDelete(centro)}
                                                                title="Eliminar"
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center text-muted">
                                                        <i className="fas fa-account-balance fa-2x mb-2"></i>
                                                        <br />
                                                        No hay centros de costos registrados
                                                        <br />
                                                        <button
                                                            className="btn btn-primary mt-2"
                                                            onClick={() => setShowModal(true)}
                                                        >
                                                            Crear primer centro de costo
                                                        </button>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal para crear/editar centro de costo */}
            {showModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header" style={{ position: 'relative' }}>
                                <h5 className="modal-title">
                                    <i className="fas fa-account-balance"></i> {editingCentro ? 'Editar Centro de Costo' : 'Nuevo Centro de Costo'}
                                </h5>
                                <button
                                    type="button"
                                    style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '16px',
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        color: '#666',
                                        cursor: 'pointer',
                                        padding: '0',
                                        lineHeight: '1'
                                    }}
                                    onClick={handleCloseModal}
                                >
                                    ×
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="codigo">
                                        Código <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.codigo ? 'is-invalid' : ''}`}
                                        id="codigo"
                                        name="codigo"
                                        value={formData.codigo}
                                        onChange={handleInputChange}
                                        placeholder="Ej: CC001"
                                        maxLength="10"
                                    />
                                    {errors.codigo && (
                                        <div className="invalid-feedback">
                                            {errors.codigo}
                                        </div>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="nombre">
                                        Nombre <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
                                        id="nombre"
                                        name="nombre"
                                        value={formData.nombre}
                                        onChange={handleInputChange}
                                        placeholder="Ej: Golondrinas"
                                    />
                                    {errors.nombre && (
                                        <div className="invalid-feedback">
                                            {errors.nombre}
                                        </div>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="descripcion">
                                        Descripción
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="descripcion"
                                        name="descripcion"
                                        value={formData.descripcion}
                                        onChange={handleInputChange}
                                        rows="3"
                                        placeholder="Descripción opcional del centro de costo..."
                                    ></textarea>
                                </div>

                                <div className="form-group">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="activo"
                                            name="activo"
                                            checked={formData.activo}
                                            onChange={handleInputChange}
                                        />
                                        <label className="form-check-label" htmlFor="activo">
                                            Centro de costo activo
                                        </label>
                                    </div>
                                    <small className="form-text text-muted">
                                        Solo los centros de costos activos estarán disponibles para asignación
                                    </small>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCloseModal}
                                >
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={confirmSubmit}
                                >
                                    <i className="fas fa-save"></i> {editingCentro ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CentroCostos;